<template>
  <div class="content" :style="styleObject">
    <div class="security-box">
      <img class="logo-img" src="@/assets/images/login.png" />
      <div class="login-text" v-if="$store.getters.authorityRoute == '/parent'">
        Welcome to Online Application System
      </div>
      <div class="login-text" v-else>
        Welcome to Application System Admin Portal
      </div>
      <div class="login-description">忘記密碼 Forget Password</div>
      <el-form
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        label-width="180px"
        :model="formLabelAlign"
      >
        <el-form-item label="已登記電郵 Registered Email:" prop="email">
          <el-input
            v-model="formLabelAlign.email"
            placeholder="Registered Email"
          >
            <template slot="prepend"><i class="el-icon-message"></i></template>
          </el-input>
        </el-form-item>
        <div>
          <img
            class="verificationCode-img"
            @click="onVerificationCodeImg"
            :src="code.image"
          />
        </div>
        <el-form-item
          label="Verification Code 驗證碼："
          prop="verificationCode"
        >
          <el-input
            show-password
            v-model="formLabelAlign.verificationCode"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onSubmit">提 交 Submit</el-button>
          <el-button type="primary" @click="onBack">返 回 Return</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reserved-text">
      Copyright by HKCCCU Logos Academy. All rights reserved.
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>
  
  <script>
import { getSetting } from "@/api/parent/setting";
import { forgetPassword, getVerificationCode } from "@/api/security";
import loadingDialog from "@/components/loadingDialog/index";
export default {
  components: { loadingDialog },
  data() {
    return {
      styleObject: {
        backgroundImage: "",
      },
      code: "",
      centerDialogVisible: false,
      formLabelAlign: {
        email: "",
        verificationCode: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "The Email cannot be empty  郵箱不能為空",
            trigger: "blur",
          },
          {
            type: "email",
            message: "郵箱格式不正確 The E-mail format is incorrect",
            trigger: ["blur", "change"],
          },
        ],
        verificationCode: [
          {
            required: true,
            message: "The verification code cannot be empty. 驗證碼不能為空。",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    setting: {
      handler(v) {
        if (v != null) {
          this.styleObject.backgroundImage = `url(${this.setting.backgroundImage1})`;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getSetting();
    this.getVerificationCode();
  },
  methods: {
    getSetting() {
      getSetting().then((v) => {
        this.setting = v.data;
      });
    },
    onVerificationCodeImg() {
      this.getVerificationCode();
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.forgetPassword();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getVerificationCode() {
      getVerificationCode().then((v) => {
        this.code = v.data;
      });
    },
    forgetPassword() {
      this.centerDialogVisible = true;
      let form = {
        email: this.formLabelAlign.email.trim(),
        verificationCode: this.formLabelAlign.verificationCode.trim(),
        verificationKey: this.code.verificationKey.trim(),
      };
      forgetPassword(form)
        .then(() => {
          this.$message.success("send success");
        })
        .finally(() => {
          this.centerDialogVisible = false;
          this.getVerificationCode();
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.content {
  height: 100% !important;
  background-color: #070060;
  background-image: url("~@/assets/images/bg.png");
  background-size: 100%;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
}
.security-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  height: 100% !important;
}
.el-form {
  width: 380px;
  display: block;
}
.el-form-item {
  color: #fff !important;
}
.login-text {
  color: #fff;
  font-size: 40px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.reserved-text {
  color: #fff;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.forgot-text {
  color: #2eac00;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}
.login-description {
  color: #72acff;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 25px;
}
.verificationCode-img {
  display: block;
  width: 141px;
}
::v-deep {
  .el-form--label-top .el-form-item__label {
    color: #fff !important;
  }
  .el-button--info {
    width: 100%;
    background-color: #337ab7;
    border-color: #337ab7;
    margin-left: 0;
    margin-bottom: 10px;
  }
  .el-button--primary {
    width: 100%;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .content {
    height: auto !important;
  }
  .security-box {
    height: auto !important;
  }
  .login-text {
    font-size: 1.25rem;
  }
  .addUser-description {
    font-size: 1.25rem;
  }
  .logo-img {
    width: auto;
    margin-left: 0;
  }
  .el-form {
    width: auto;
    margin-right: 0;
  }
  .reserved-text {
    bottom: 0;
    position: relative;
    text-align: center;
  }
}
</style>